"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class Consignees {
}
exports.Consignees = Consignees;
//# sourceMappingURL=Consignees.js.map